<script type="text/babel">
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapMutations(['addAlert']),
        ...mapActions([
            'addPriceAsync',
            'updatePriceAsync',
            'addProductAsync',
            'updateProductAsync'
        ]),
        addProduct ({item, price}) {
            this.addProductAsync({product: item, price: price}).then((data) => {
                this.addAlert({
                    title: 'Successfully ',
                    type: 'success',
                    body: `added product with product id ${data.id}`
                });
            });
        }
    }
};

</script>

